<template>
<div class="chapter">
<div class="inner_page">
<p class="title"><a id="page_xiv"></a><a id="page_xv"></a>TEJANO SOUTH TEXAS</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292705111_halftitle1.vue?9bbe9554